import ToggleItem from './toggle_item';

export default class Paintformat extends ToggleItem {
  constructor() {
    super('paintformat');
  }

  setState() {}
}
